import * as React from 'react'
import PropTypes from 'prop-types'
import SubjectToCSSName from '../../../less/SubjectToCSSName'
import '../typography.css'
import './text.css'

const SIZE_SCALE: { [size: ?string]: number } = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
}
export default class Text extends React.PureComponent {

  render() {
    const {
      align = 'left',
      fontWeight = 'normal',
      children,
      color = 'body',
      inline = false,
      italic = false,
      overflow = 'breakWord',
      size = 'md',
      smSize,
      mdSize,
      lgSize,
      leading = 'short',
      truncate = false,
      __dangerouslyIncreaseLineHeight = false,
      dangerouslySetInnerHTML,
      setRef,
      ...rest
    } = this.props

    const cs = [
      'Text',
      `fontSize${SIZE_SCALE[size]}`,
      smSize && `smFontSize${SIZE_SCALE[smSize]}`,
      mdSize && `mdFontSize${SIZE_SCALE[mdSize]}`,
      lgSize && `lgFontSize${SIZE_SCALE[lgSize]}`,
      leading === 'short' && 'leadingShort',
      (leading === 'tall' || __dangerouslyIncreaseLineHeight) &&
        'leadingTall',
      `text-align--${align}`,
      overflow === 'breakWord' && 'breakWord',
      truncate && 'truncate',
      italic && 'fontStyleItalic',
      !italic && 'fontStyleRegular',
      `fontWeight--${fontWeight}`,
      `text-color--${color}`,
    ].join(' ')
    const Tag = inline ? 'span' : 'div'

    return React.createElement(
      Tag,
      {
        className: cs,
        dangerouslySetInnerHTML,
        ref: setRef,
        ...(truncate && typeof children === 'string'
          ? { title: children }
          : null),
        ...rest
      },
      children
    )
  }
}

Text.propTypes = {
  __dangerouslyIncreaseLineHeight: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
  children: PropTypes.node,
  color: PropTypes.oneOf([
    'blue',
    'darkGray',
    'midGray',
    'coolGray',
    'lightGray',
    'white',
    'body',
    'streakYellow',
    ...Object.values(SubjectToCSSName).map(color=>`${color}-nav`),
    ...Object.values(SubjectToCSSName).map(color=>`${color}-search`),
    ...Object.values(SubjectToCSSName).map(color=>`${color}-subject`),
    ...Object.values(SubjectToCSSName).map(color=>`${color}-cta`),
  ]),
  fontWeight: PropTypes.oneOf([
    'normal',
    'book',
    'medium',
    'bold'
  ]),
  inline: PropTypes.bool,
  italic: PropTypes.bool,
  leading: PropTypes.oneOf(['tall', 'short']),
  lgSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  mdSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  overflow: PropTypes.oneOf(['normal', 'breakWord']),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  smSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  truncate: PropTypes.bool,
  dangerouslySetInnerHTML: PropTypes.object,
  setRef: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/core/components/typography/text/Text.js